import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

import componentStyles from 'assets/theme/views/admin/react-bs-table.js'

const useStyles = makeStyles(componentStyles)

function NPHTotalRevenue({ revenueBreakdown, period }) {
    const classes = useStyles()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (period && period !== 'thisWeek') {
            setOpen(true)
        }
    }, [period])

    if (!revenueBreakdown) return null

    const {
        topupTotal,
        weeklyDeliveryTotal,
        weeklyDeliveryInvoiceCount,
        weeklyDeliveryLeadCount,
        startPensionTotal,
        startPensionLeadCount,
    } = revenueBreakdown

    const grandTotal = topupTotal + weeklyDeliveryTotal + startPensionTotal

    const rowStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem 0',
        borderBottom: '1px solid #e9ecef'
    }

    const totalRowStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.75rem 0 0.25rem',
        fontWeight: 700
    }

    return (
        <Card style={{ marginBottom: '2rem' }}>
            <CardHeader
                subheader={
                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                        <Box
                            component={Typography}
                            variant='h2'
                            marginBottom='0!important'
                        >
                            <Box component='span'>Revenue Breakdown</Box>
                        </Box>
                        <IconButton size='small' onClick={() => setOpen(o => !o)}>
                            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Box>
                }
                classes={{ root: classes.cardHeaderRoot }}
            />
            <Collapse in={open}>
                <CardContent>
                    <Box style={rowStyle}>
                        <Box>
                            <Typography variant='body1'><strong>Topups</strong></Typography>
                            <Typography variant='caption' color='textSecondary'>All topups should be added as payments on the system for accuracy.</Typography>
                        </Box>
                        <Box textAlign='right'>
                            <Typography variant='body1'>€{topupTotal.toFixed(2)}</Typography>
                        </Box>
                    </Box>
                    <Box style={rowStyle}>
                        <Box>
                            <Typography variant='body1'><strong>Weekly Deliveries</strong></Typography>
                            <Typography variant='caption' color='textSecondary'>{weeklyDeliveryInvoiceCount} invoice{weeklyDeliveryInvoiceCount !== 1 ? 's' : ''} &middot; {weeklyDeliveryLeadCount} lead{weeklyDeliveryLeadCount !== 1 ? 's' : ''}</Typography>
                        </Box>
                        <Box textAlign='right'>
                            <Typography variant='body1'>€{weeklyDeliveryTotal.toFixed(2)}</Typography>
                        </Box>
                    </Box>
                    <Box style={rowStyle}>
                        <Box>
                            <Typography variant='body1'><strong>Start Pensions (AA)</strong></Typography>
                            <Typography variant='caption' color='textSecondary'>{startPensionLeadCount} lead{startPensionLeadCount !== 1 ? 's' : ''} &middot; €40 per lead</Typography>
                        </Box>
                        <Box textAlign='right'>
                            <Typography variant='body1'>€{startPensionTotal.toFixed(2)}</Typography>
                        </Box>
                    </Box>
                    <Box style={totalRowStyle}>
                        <Typography variant='body1'><strong>Total</strong></Typography>
                        <Typography variant='body1'><strong>€{grandTotal.toFixed(2)}</strong></Typography>
                    </Box>
                </CardContent>
            </Collapse>
        </Card>
    )
}

export default NPHTotalRevenue

